import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import DocumentScanner from '@/components/DocumentScanner';
import { useLanguage } from '@/contexts/LanguageContext';

const ScannerPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-slate-900/95 backdrop-blur border-b border-slate-800">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div>
            <h1 className="font-bold text-xl">{t('document_scanner')}</h1>
            <p className="text-sm text-slate-400">{t('scan_and_save')}</p>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-8">
        <DocumentScanner 
          onSave={(doc) => console.log('Saved:', doc)}
          onShare={(result) => console.log('Shared:', result)}
        />
      </main>
    </div>
  );
};

export default ScannerPage;
